import { Location } from '@hakimo-ui/hakimo/types';
import { useCanUpdateLocation } from '@hakimo-ui/hakimo/util';
import { Alert, Button } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import UploadFloorplanModal from './UploadFloorplanModal';

interface Props {
  location: Location;
}

export function Floorplan(props: Props) {
  const { location } = props;
  const canUpdateLocation = useCanUpdateLocation();
  const [showUploadFloorplanModal, setShowUploadFloorplanModal] =
    useState(false);

  const onClickUploadFloorplan = () => setShowUploadFloorplanModal(true);
  const onCloseModal = () => setShowUploadFloorplanModal(false);

  return (
    <div>
      {canUpdateLocation && (
        <div className="pb-4 text-end">
          <Button onClick={onClickUploadFloorplan} variant="primary">
            Upload Floorplan
          </Button>
        </div>
      )}
      {location.floor_plan ? (
        <div className="bg-onlight-bg-2 dark:bg-dark-bg flex justify-center">
          <img src={location.floor_plan} alt="Floorplan" />
        </div>
      ) : (
        <div className="pt-4">
          <Alert>Floorplan not available</Alert>
        </div>
      )}
      {showUploadFloorplanModal && (
        <UploadFloorplanModal
          locationId={location.id.toString()}
          locationName={location.name}
          onClose={onCloseModal}
        />
      )}
    </div>
  );
}

export default Floorplan;
